export default __webpack_public_path__ + "static/media/animale_logo.061026d3.svg";